module.exports = __webpack_public_path__ + "img/4.387be49b.jpg";